import BaseXMLGenerator from './xlsx-tableexport-generator.js';
import AppDataSetting from '@/data/app-data-setting.js'

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []

        row.push(data['project-name'])
        row.push(data['task-name'])
        row.push(data['content'])
        row.push(data['hours'])
        row.push(data['money'])
    
        rows.push(row)
    }
    let headerList = ['專案', '任務', '工作內容', '時數', '獎金']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;